import { render, staticRenderFns } from "./settings-connection-info-pane.vue?vue&type=template&id=22177121&scoped=true"
import script from "./settings-connection-info-pane.vue?vue&type=script&lang=js"
export * from "./settings-connection-info-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-connection-info-pane.vue?vue&type=style&index=0&id=22177121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22177121",
  null
  
)

export default component.exports